const WEBINAR_ID_KEY = "webinarId"

export function setWebinarIdInLocalStorage(webinarId: string) {
    document.cookie = `${WEBINAR_ID_KEY}=${encodeURIComponent(webinarId)}; path=/;`
}

export function getWebinarIdFromLocalStorage(): string | null {
    const match = document.cookie.match(new RegExp('(?:^|; )' + WEBINAR_ID_KEY + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
}